import {
  GET_SECTION_API_ACCESS,
  GET_SECTION_DATE,
  GET_SECTION_ISSUER,
  GET_SECTION_ROUTE,
  GET_SECTION_ROUTE_CATEGORY,
  LOAD_REQUEST
} from '../types';

const initialState = {
  sectionIssuer: [],
  sectionAccessKey: [],
  sectionRoute: [],
  sectionRouteCategory: [],
  sectionDate: [],
  isLoading: false
};

export default function ReportsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SECTION_ISSUER:
      return {
        ...state,
        sectionIssuer: action.payload,
        isLoading: false
      };
    case GET_SECTION_API_ACCESS:
      return {
        ...state,
        sectionAccessKey: action.payload,
        isLoading: false
      };
    case GET_SECTION_DATE:
      return {
        ...state,
        sectionDate: action.payload,
        isLoading: false
      };
    case GET_SECTION_ROUTE:
      return {
        ...state,
        sectionRoute: action.payload,
        isLoading: false
      };
    case GET_SECTION_ROUTE_CATEGORY:
      return {
        ...state,
        sectionRouteCategory: action.payload,
        isLoading: false
      };
    case LOAD_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
}
